<template>
  <el-container style="min-width: 1200px; height: 100%" class="web__layout">
    <!--
    <layout-header></layout-header>
    -->
    <el-main style="padding: 0px 0 0; overflow: hidden">
      <router-view
        v-wechat-title="changeTitle(generateTitle($route.meta.title))"
      />
      <!--
      <layout-footer></layout-footer>
      -->
    </el-main>
  </el-container>
</template>

<script>
import { generateTitle } from "@/utils/i18n";
import LayoutHeader from "./components/LayoutHeader.vue";
import LayoutFooter from "./components/LayoutFooter.vue";
export default {
  components: {
    //LayoutHeader,
    //LayoutFooter
  },
  methods: {
    changeTitle(title) {
      return title == "首页" ? "订单管理系统" : title;
    },
    generateTitle,
  },
};
</script>
